import "./App.css";

import * as React from "react";
import { useRef } from "react";
import Checkbox from "@mui/joy/Checkbox";

// Material
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { CardActionArea } from "@mui/material";

// Lab
import LoadingButton from "@mui/lab/LoadingButton";

// Joy
import RadioGroup from "@mui/joy/RadioGroup";
import Radio from "@mui/joy/Radio";
import Box from "@mui/joy/Box";

import { DropzoneArea } from "mui-file-dropzone";

import ReactGA from 'react-ga';
const TRACKING_ID = "G-41TRFJLM60"; 
ReactGA.initialize(TRACKING_ID);

//useAnalyticsEventTracker.jsx

// const useAnalyticsEventTracker = (category="Blog category") => {
//   const eventTracker = (action = "test action", label = "test label") => {
//     ReactGA.event({category, action, label});
//   }
//   return eventTracker;
// }


// import CustomNonLinearScale from './CustomNonLinearScale';

// import Ai from './assets/ai.js'
// import Mao from './assets/mao.js'
// import Wen from './assets/wen.js'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function App() {

  const uploadRef = useRef();
  const scrollCallback = () => {
    uploadRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  // const gaEventTracker = useAnalyticsEventTracker('Contact us');

  const card = (book_name, author_name, selected_card) => {
    return (
      <React.Fragment>
        <CardContent
          sx={{
            bgcolor:
              selected_card === book_name ? "lightBlue" : "background.paper",
          }}
        >
          {/* <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom> */}
          {/* Word of the Day */}
          {/* </Typography> */}
          <Typography variant="h6" component="div">
            {book_name}
          </Typography>
          <Typography sx={{ mb: 0.5 }} color="text.secondary">
            {author_name}
          </Typography>
          <Typography variant="body3">
            Book
            <br />
          </Typography>
        </CardContent>
        {/* <CardActions> */}
        {/* <Button size="small">Learn More</Button> */}
        {/* </CardActions> */}
      </React.Fragment>
    );
  };

  const exampleDeckCard = (book_name, author_name) => {
    return (
      <Grid item xs={12} md={6} lg={4} xl={3}>
        <CardActionArea
          onClick={() => {
            setSelectedCard(book_name);
            setDeckname(book_name);
          }}
        >
          <Card variant="outlined">
            {card(book_name, author_name, selected_card)}
          </Card>
        </CardActionArea>
      </Grid>
    );
  };

  // Deck settings 
  const [files, setFiles] = React.useState();
  const [deckname, setDeckname] = React.useState("Animal Farm");
  // const [HSKvalue, setHSKValue] = React.useState(1);
  const [pinyin, setPinyin] = React.useState("diacritics");
  const [traditional, setTraditional] = React.useState(true);
  const [part_of_speech, setPartOfSpeech] = React.useState(true);
  const [audio, setAudio] = React.useState(false);
  const [zhuyin, setZhuyin] = React.useState(false);
  const [example_sentences, setExampleSentences] = React.useState(false);

  // Page control
  const [tab, setTab] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [selected_card, setSelectedCard] = React.useState("Animal Farm");

  const submitForm = async (event) => {

    console.log("Loading: " + loading)

    console.log("Submitting form...");
    const form = new FormData();

    form.append("deckname", deckname);
    form.append("pinyin", pinyin);
    form.append("include_traditional", traditional);
    form.append("include_part_of_speech", part_of_speech);
    form.append("include_audio", audio);
    form.append("include_zhuyin", zhuyin);
    form.append("include_example_sentences", audio);
    form.append("export_type", "deck");

    let url = "";
    if (tab === 0) {
      console.log("Files: " + files);
      form.append("example_deck", selected_card);
      // url = "http://0.0.0.0:8080/deck"; // for running locally
      url = "https://hammerhead-app-ygoyv.ondigitalocean.app/deck";
    } else if (tab === 1) {
      form.append("files", files[0]);
      // url = "http://0.0.0.0:8080/file"; // for running locally
      url = "https://hammerhead-app-ygoyv.ondigitalocean.app/file";
    } else {
      setLoading(false);
      console.log("Loading: " + loading)
      return;
    }

    // console.log("HSKValue: " + HSKvalue);

    fetch(url, {
      method: "POST",
      body: form,
    })
      .then((response) => {
        console.log("Response: " + response);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `${deckname}.apkg`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(downloadUrl);
        setLoading(false);
        console.log("Loading: " + loading)
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
        setLoading(false);
      });
  };
  const handleSetTab = (event, newValue) => {
    setTab(newValue);
    // if (newValue === 1) {
      setDeckname("Deck Name");
    // }
  };

  return (
    <div className="App">
      <header>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Yeseva+One&display=swap"
          rel="stylesheet"
        />
      </header>
      <body>
        <div className="BGCards">
          {/* <Ai x_pos="84%" i_val={6}/>
          <Ai x_pos="0%" i_val={7}/>
          <Mao x_pos="16%" i_val={9}/>
          <Ai x_pos="66%" i_val={10}/>
          <Ai x_pos="-10%" i_val={11}/>
          <Ai x_pos="110%" i_val={13}/>
          <Mao x_pos="35%" i_val={14}/> 
          <Ai x_pos="50%" i_val={14}/>
          <Wen x_pos="75%" i_val={17}/>
          <Ai x_pos="-25%" i_val={18}/>
          <Wen x_pos="2%" i_val={19}/> */}
          {/* <Wen x_pos="-15%" i_val={21}/> */}
          {/* <Mao x_pos="98%" i_val={22}/> */}
          {/* <Ai x_pos="130%" i_val={23}/> */}
        </div>

        <div className="MainContent">
          <h1 className="MainTitle yeseva-one-regular">AutoAnki</h1>
          <h2 className="SecondaryTitle">Easily Make Chinese Decks for Anki</h2>
          <Button variant="contained" onClick={scrollCallback}>
            Start
          </Button>

          <div className="SectionOne" ref={uploadRef}>
            <Tabs value={tab} onChange={handleSetTab}>
              <Tab label="Example Decks" />
              <Tab label="Upload File" />
            </Tabs>

            <TabPanel value={tab} index={0}>
              <Grid container spacing={3}>
                {exampleDeckCard("Animal Farm", "George Orwell")}
                {exampleDeckCard("Charlotte's Web", "E. B. White")}
                {exampleDeckCard("Crime and Punishment", "Fyodor Dostoevsky")}
                {exampleDeckCard("Dune", "Frank Herbert")}
                {exampleDeckCard("Lord of the Rings", "J. R. R. Tolkien")}
                {exampleDeckCard("Three Body Problem", "Liu Cixin")}
                {exampleDeckCard("Harry Potter", "J. K. Rowling")}
                {exampleDeckCard("The Hobbit", "J. R. R. Tolkien")}
                {exampleDeckCard(
                  "The Little Prince",
                  "Antoine de Saint-Exupéry"
                )}
                {exampleDeckCard("To Kill a Mockingbird", "Harper Lee")}
              </Grid>
            </TabPanel>

            <TabPanel value={tab} index={1}>
              <h2>Please Select a File</h2>
              <DropzoneArea

                onChange={(files) => {
                  setFiles(files);
                }}
                filesLimit={2}
              />
              <h4 style={{ marginBottom: "1%" }}>
                Supported formats: TXT, PDF, Pleco export, and epub
              </h4>
              <a
                style={{ fontSize: "15px" }}
                href="https://forms.gle/qRgyDRBL3C3rizjt7"
              >
                Feedback
              </a>
            </TabPanel>

            {/* <h4>What language is this?</h4> */}
            {/* <CustomBasicSelect /> */}
          </div>

          <div className="SectionTwo">
            <h1>Settings</h1>

            <div className="SectionTwoInner">
              <div className="flex-child CardDisplay">
                <div className="CardFront">
                  {traditional ? <h1>猫 [貓]</h1> : <h1>猫</h1>}
                </div>
                <div className="CardBack">
                  <div className="CardPinYinPlay">
                    {pinyin === "diacritics" ? (
                      <h3 className="CardPinYin">māo</h3>
                    ) : (
                      <h3 className="CardPinYin">mao1</h3>
                    )}
                    <img
                      className="CardPlay"
                      alt="Play Icon"
                      style={{ display: audio ? "block" : "none" }}
                      src={require("./assets/play.png")}
                    />
                  </div>
                  <h3
                    className="CardZhuyin"
                    style={{ display: zhuyin ? "block" : "none" }}
                  >
                    ㄇㄠ
                  </h3>
                  <h4
                    className="CardPOS"
                    style={{ display: part_of_speech ? "block" : "none" }}
                  >
                    noun
                  </h4>
                  <h3 className="CardDefinition">Cat</h3>
                  <h4
                    className="CardExampleSentences"
                    style={{ display: example_sentences ? "block" : "none" }}
                  >
                  你的猫很可爱
                  </h4>
                  <h4
                    className="CardExampleSentences"
                    style={{
                      display: example_sentences ? "block" : "none",
                      color: "gray",
                      marginTop: "1%",
                      fontSize: "0.8em",
                    }}
                  >
                    Your cat is very cute
                  </h4>
                </div>
              </div>

              <div className="flex-child SettingsRight">
                <h2>What to call it</h2>
                <TextField
                  id="outlinedControlled"
                  variant="outlined"
                  label={"Deck Name"}
                  value={deckname}
                  onChange={(event) => {
                    setDeckname(event.target.value);
                  }}
                />

                {/* <h2>What to include</h2> */}
                {/* <CustomNonLinearScale /> */}

                <h2>What to show</h2>
                <div
                  className="BubbledOption"
                  style={{ paddingLeft: "0.5rem", marginBottom: "0.3rem" }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {/* <Typography
                    id="segmented-controls-example"
                    fontWeight="lg"
                    fontSize="sm"
                  >
                    Pinyin:
                  </Typography> */}
                    <RadioGroup
                      orientation="horizontal"
                      aria-labelledby="segmented-controls-example"
                      name="justify"
                      value={pinyin}
                      onChange={(event) => setPinyin(event.target.value)}
                      sx={{
                        minHeight: 35,
                        padding: "4px",
                        borderRadius: "12px",
                        bgcolor: "neutral.softBg",
                        "--RadioGroup-gap": "4px",
                        "--Radio-actionRadius": "8px",
                      }}
                    >
                      <Radio
                        key={"numbers"}
                        color="neutral"
                        value={"numbers"}
                        disableIcon
                        label={"Ni3Hao3"}
                        variant="plain"
                        sx={{
                          px: 2,
                          alignItems: "center",
                        }}
                        slotProps={{
                          action: ({ checked }) => ({
                            sx: {
                              ...(checked && {
                                bgcolor: "background.surface",
                                boxShadow: "sm",
                                "&:hover": {
                                  bgcolor: "background.surface",
                                },
                              }),
                            },
                          }),
                        }}
                      />
                      <Radio
                        key={"diacritics"}
                        color="neutral"
                        value={"diacritics"}
                        disableIcon
                        label={"Nǐ Hǎo"}
                        variant="plain"
                        sx={{
                          px: 2,
                          alignItems: "center",
                        }}
                        slotProps={{
                          action: ({ checked }) => ({
                            sx: {
                              ...(checked && {
                                bgcolor: "background.surface",
                                boxShadow: "sm",
                                "&:hover": {
                                  bgcolor: "background.surface",
                                },
                              }),
                            },
                          }),
                        }}
                      />
                    </RadioGroup>
                  </Box>
                </div>
                <br />
                <Checkbox
                  color="neutral"
                  disabled={false}
                  label="Traditional"
                  size="lg"
                  defaultChecked={traditional}
                  onChange={(event) => {
                    setTraditional(event.target.checked);
                  }}
                  variant="outlined"
                />
                <br />
                <Checkbox
                  color="neutral"
                  disabled={false}
                  label="Part of speech (noun, verb...)"
                  size="lg"
                  variant="outlined"
                  defaultChecked={part_of_speech}
                  onChange={(event) => {
                    setPartOfSpeech(event.target.checked);
                  }}
                />
                <br />
                <Checkbox
                  color="neutral"
                  disabled={false}
                  label="Zhuyin"
                  size="lg"
                  variant="outlined"
                  defaultChecked={zhuyin}
                  onChange={(event) => {
                    setZhuyin(event.target.checked);
                  }}
                />
                <br />
                <Checkbox
                  color="neutral"
                  disabled={true}
                  label="Audio (Coming soon)"
                  size="lg"
                  variant="outlined"
                  defaultChecked={audio}
                  onChange={(event) => {
                    setAudio(event.target.checked);
                  }}
                />
                <br />
                <Checkbox
                  color="neutral"
                  disabled={true}
                  label="Example Sentences (Coming Soon)"
                  size="lg"
                  variant="outlined"
                  defaultChecked={example_sentences}
                  onChange={(event) => {
                    setExampleSentences(event.target.checked);
                  }}
                />
                <br />
                <br />
                <br />
                <LoadingButton
                  variant="contained"
                  onClick={() => {
                    console.log("Clicked");
                    setLoading(true);
                    submitForm()
                  }}
                  loading={loading}
                >
                  Convert
                </LoadingButton>
                <p style={{fontSize: '0.8rem'}}>(For large decks, this can take up to a miniute)</p>
              </div>
            </div>
          </div>

        </div>
        <div className="Bottom">
          {/* <h2 > */}
          <div>
            Project made by{" "}
            <a href="https://github.com/jarviscog">@jarviscog</a>
          </div>
          |
          <a
            className="BottomLink"
            href="https://github.com/jarviscog/autoanki"
          >
            Github
          </a>
          |{/* </h2> */}
          {/* <h2 > */}
          <a className="BottomLink" href="https://forms.gle/mUFDrwYg99Fmr42G6">
            Feedback
          </a>
          {/* </h2> */}
        </div>
      </body>
    </div>
  );
}

export default App;



